export default {"src":"/_next/static/media/1.a9f82753.svg","height":400,"width":1200};